import { useEffect, useMemo, useCallback } from "react";
import Statsig from "statsig-js";
import getMeaningfulExperimentNames from "../utils/statsig-ab-utils/get-meaningful-experiment-names";
import { useSelector, useDispatch } from "react-redux";
import { setExperiment as setExperimentConnect } from "../components/shared/ab-experiment/actions";

const useExperiments = ({ experimentKeys }) => {
    const selectExperiments = useMemo(() =>
        (store) => store?.abExperiment || {},
    []);

    const allExperiments = useSelector(selectExperiments);
    const { statsigConfig: { initialized = false } } = allExperiments || {};
    const dispatch = useDispatch();

    const memoizedExperimentKeys = useMemo(() => experimentKeys, [experimentKeys]);

    const processExperiments = useCallback(() => {
        if (initialized && process.env.STATSIG_SECRET_CSR_KEY) {
            memoizedExperimentKeys.forEach((experimentName) => {
                const experimentData = Statsig.getExperiment(experimentName);
                const { value } = experimentData || {};
                const { key = "" } = value || {};
                dispatch(setExperimentConnect(
                    getMeaningfulExperimentNames(experimentName),
                    key
                ));
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialized]);

    useEffect(() => {
        processExperiments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [processExperiments]);

    return null;
};

export default useExperiments;
